export const DEFAULT_MAX_TURNS = 50;
